<template>
	<form @submit.prevent="createLead()">
		<div class="row">
			<div class="col-sm-12">
				<div class="row">
					<div class="col-sm-12">
						<div class="row mt-4">
							<div class="form-group col-sm-3 mb-2">
								<BaseInput
									name="Phone"
									label="Mobile Number"
									type="number"
									v-model="data.phone"
									class="form-control form-control-lg dashInput"
									rules="required|min:9|max:10"
									@valError="valError"
									@valSuccess="valSuccess"
								/>
							</div>
							<div class="form-group col-sm-3 mb-2">
								<BaseInput
									name="Email"
									label="Email"
									type="email"
									v-model="data.email"
									class="form-control form-control-lg dashInput"
									rules="email"
									@valError="valError"
									@valSuccess="valSuccess"
								/>
							</div>
							<div class="form-group col-sm-6 mb-2">
								<div class="row">
									<div class="form-group col-sm-4">
										<BaseMultiSelect
											@update:value="setSalutation"
											:options="multiSelectState.salutations"
											:defaultData="data.salutation"
											rules="required"
											:required="true"
											name="Salutation"
											@valError="valError"
											@valSuccess="valSuccess"
										/>
									</div>
									<div class="form-group col-sm-8">
										<BaseInput
											name="First Name"
											label="First Name"
											type="text"
											v-model="data.firstName"
											class="form-control form-control-lg dashInput"
											rules="required|min:3|max:20"
											:required="true"
											@valError="valError"
											@valSuccess="valSuccess"
										/>
									</div>
								</div>
							</div>
							<div class="form-group col-sm-3 mb-2">
								<BaseInput
									name="Last Name"
									label="Last Name"
									type="text"
									v-model="data.lastName"
									class="form-control form-control-lg dashInput"
									:required="true"
									rules="required|min:3|max:20"
									@valError="valError"
									@valSuccess="valSuccess"
								/>
							</div>
							<div class="form-group col-sm-3 mb-2">
								<BaseInput
									name="Address"
									label="Address"
									type="text"
									class="form-control form-control-lg dashInput"
									v-model="data.address"
									rules="required|min:10|max:200"
									@valError="valError"
									@valSuccess="valSuccess"
								/>
							</div>
							<div class="form-group col-sm-3 mb-2">
								<BaseInput
									name="city"
									label="City"
									type="text"
									v-model="data.city"
									class="form-control form-control-lg dashInput"
									rules="required|min:3|max:50"
									@valError="valError"
									@valSuccess="valSuccess"
								/>
							</div>
							<div class="form-group col-sm-3 mb-2">
								<BaseInput
									name="Alternate Phone"
									label="Alternate Mobile Number"
									type="text"
									v-model="data.alternatePhone"
									class="form-control form-control-lg dashInput"
									rules="min:9|max:10"
									@valError="valError"
									@valSuccess="valSuccess"
								/>
							</div>
							<div class="form-group col-sm-3 mb-2">
								<BaseInput
									name="Alternate Email"
									label="Alternate Email"
									type="email"
									v-model="data.alternateEmail"
									class="form-control form-control-lg dashInput"
									rules="email"
									@valError="valError"
									@valSuccess="valSuccess"
									@required="true"
								/>
							</div>

							<div class="form-group col-sm-3 mb-2">
								<BaseMultiSelect
									@update:value="setCustomerType"
									:defaultData="data.customerType"
									:options="multiSelectState.customerType"
									rules="required"
									name="Customer Type"
									@valError="valError"
									@valSuccess="valSuccess"
								/>
							</div>
							<div class="form-group col-sm-3 mb-2">
								<BaseMultiSelect
									@update:value="setLeadSource"
									:options="multiSelectState.leadSources"
									:defaultData="data.leadSource"
									rules="required"
									name="Lead Source"
									@valError="valError"
									@valSuccess="valSuccess"
								/>
							</div>
							<div class="form-group col-sm-3 mb-2">
								<BaseMultiSelect
									@update:value="setLeadPriority"
									:options="multiSelectState.leadPriority"
									:defaultData="data.leadPriority"
									rules="required"
									name="Lead Priority"
									@valError="valError"
									@valSuccess="valSuccess"
								/>
							</div>
							</div>
							
						</div>


					

							<div class="form-group col-sm-3 mb-2">
								<BaseMultiSelect
									@update:value="setLeadStatus"
									:options="multiSelectState.leadStatus"
									:defaultData="data.leadStatus"
									rules="required"
									name="Lead Status"
									@valError="valError"
									@valSuccess="valSuccess"
								/>
							</div>

							<div class="form-group col-sm-9 mb-2">
								<div class="row">
									<div class="form-group col-sm-3">
										<BaseInput
											name="Adults"
											label="No. of Adults"
											type="number"
											v-model="data.adults"
											:min="1"
											:required="true"
											class="form-control form-control-lg dashInput"
											rules="required|min:1"
											@valError="valError"
											@valSuccess="valSuccess"
										/>
									</div>
							<div class="form-group col-sm-3">
								<BaseInput
									name="Children"
									label="Children (5-12 age)"
									type="number"
									:min="0"
									v-model="data.childrenFiveTwelve"
									class="form-control form-control-lg dashInput"
									rules="required|min:1|max:2"
									@valError="valError"
									@valSuccess="valSuccess"
								/>
							</div>
							<div class="form-group col-sm-3">
								<BaseInput
									name="Children"
									label="Children (2-5 age)"
									type="number"
									:min="0"
									v-model="data.childrenTwoFive"
									class="form-control form-control-lg dashInput"
									rules="required|min:1|max:2"
									@valError="valError"
									@valSuccess="valSuccess"
								/>
							</div>
							<div class="form-group col-sm-3">
								<BaseInput
									name="Infants"
									label="Infants (0-2 age)"
									type="number"
									:min="0"
									v-model="data.infants"
									class="form-control form-control-lg dashInput"
									rules="required|min:1|max:2"
									@valError="valError"
									@valSuccess="valSuccess"
								/>
							</div>
						</div>
					</div>

					<div class="form-group col-sm-3 mb-2">
						<BaseMultiSelect
							@update:value="setTripType"
							:options="multiSelectState.tripType"
							:defaultData="data.tripType"
							rules="required"
							name="Trip Type"
							@valError="valError"
							@valSuccess="valSuccess"
							:required="true"
						/>
					</div>

					<div class="form-group col-sm-3 mb-2">
						<BaseMultiSelect
							@update:value="setTag"
							:options="multiSelectState.tagsSelect"
							:defaultData="data.tags"
							:closeOnSelect="false"
							rules="required"
							name="Tags"
							mode="multiple"
							@valError="valError"
							@valSuccess="valSuccess"
						/>
					</div>
					<div v-if="!shouldAssign" class="form-group col-sm-3 mb-2">
						<BaseMultiSelect
							@update:value="setAssignedTo"
							:options="multiSelectState.usersSelect"
							:defaultData="data.assignedTo"
							rules="required"
							name="Assigned To"
							@valError="valError"
							@valSuccess="valSuccess"
						/>
					</div>
					<!-- <div class="col-sm-3">
						<BaseInput
							name="Time"
							label="Reminder Time"
							type="time"
							v-model="data.destination"
							class="form-control form-control-lg dashInput"
							rules="required"
							@valError="valError"
							@valSuccess="valSuccess"
							:required="true"
						/>
					</div> -->
					<div v-if="data.phone" class="col-sm-12 bg-warning py-2 mb-2">
						<div
								class="col-sm-6 fs-51"
							>
								<input
									class="form-check-input"
									type="checkbox"
									id="Checkbox-whatsapp"
									value="whatsapp"
									v-model="data.whatsappOptIn"
								/>
								<label
									class="form-check-label mx-2 text-dark"
									for="Checkbox-whatsapp"
									><i class="bi bi-whatsapp text-success"></i> Mark user <a class="text-decoration-none" href="https://www.whatsapp.com/legal/business-policy/" rel="noreferrer noopener" target="_blank">opt in</a> to receive whatsapp messages </label
								>
							
						</div>
					</div>
					<div class="form-group row mb-2">
						<div
							v-for="(enquiry, index) in multiSelectState.enquiryType"
							:key="`${index}-enquiry`"
							class="col-sm-3"
						>
							<input
								class="form-check-input"
								type="checkbox"
								:id="`Checkbox-${enquiry.replace(' ', '')}`"
								:value="enquiry.replace(' ', '')"
								v-model="data.enquiryType"
							/>
							<label
								class="form-check-label mx-2 text-dark"
								:for="`Checkbox-${enquiry}`"
								>{{ enquiry }}</label
							>
						</div>
					</div>
					

					<div class="form-group col-sm-12 mt-2" v-if="data.enquiryType.length">
						<div
							v-for="(component, index) in data.enquiryType"
							:key="`${index}-compo`"
						>
							<LeadPackage v-if="component === 'Package'" />

							<DynamicMultiplier
								v-if="component === 'Forex'"
								:name="`Lead${component}`"
								stateKey="forex"
							/>

							<DynamicMultiplier
								v-if="component === 'HotelBooking'"
								:name="`Lead${component}`"
								stateKey="hotelBooking"
							/>

							<DynamicMultiplier
								v-if="component === 'Visa'"
								:name="`Lead${component}`"
								stateKey="visa"
							/>
							<DynamicMultiplier
								v-if="component === 'TravelInsurance'"
								:name="`Lead${component}`"
								stateKey="travelInsurance"
							/>
							<DynamicMultiplier
								v-if="component === 'Sightseeing'"
								:name="`Lead${component}`"
								stateKey="sightseeing"
							/>
							<DynamicMultiplier
								v-if="component === 'Transport'"
								:name="`Lead${component}`"
								stateKey="transport"
							/>

							<DynamicMultiplier
								v-if="component === 'FlightBooking'"
								:name="`Lead${component}`"
								stateKey="flightBooking"
							/>
							<LeadOther v-if="component === 'Other'" />
							<LeadCustomizePackage v-if="component === 'CustomizePackage'" />
						</div>
					</div>

					<div class="form-group col-sm-12 mt-2">
						<div class="row">
							<div class="col-sm-12">
								<input
									class="form-check-input"
									type="checkbox"
									id="Checkbox-reminder"
									value="remainder"
									v-model="data.reminder.status"
								/>
								<label
									class="form-check-label mx-2 text-dark"
									for="Checkbox-reminder"
									>Reminder</label
								>
							</div>
						</div>

						<div v-if="data.reminder.status" class="row">
							<div class="col-sm-3">
								<BaseInput
									name="Date"
									label="Reminder Date"
									type="date"
									:min="`${new Date().getFullYear()}-${
										new Date().getMonth() + 1 < 10
											? '0' + (new Date().getMonth() + 1)
											: new Date().getMonth() + 1
									}-${new Date().getDate() + 1}`"
									v-model="data.reminder.date"
									class="form-control form-control-lg dashInput"
									rules="required"
									@valError="valError"
									@valSuccess="valSuccess"
								/>
							</div>
							<div class="col-sm-3">
								<BaseInput
									name="Time"
									label="Reminder Time"
									type="time"
									v-model="data.reminder.time"
									class="form-control form-control-lg dashInput"
									rules="required"
									@valError="valError"
									@valSuccess="valSuccess"
								/>
							</div>

							<div class="col-sm-12">
								<BaseTextArea
									v-model="data.reminder.description"
									name="Reminder Description"
									label="Description"
									@valError="valError"
									@valSuccess="valSuccess"
								/>
							</div>
						</div>
					</div>

					<!-- <div class="form-group col-sm-12 mt-2">
						<div class="row">
							<div class="col-sm-12">
								<input
									class="form-check-input"
									type="checkbox"
									id="Checkbox-reminder"
									value="remainder"
									v-model="attachmentState.enabled"
								/>
								<label
									class="form-check-label mx-2 custom-dark-text"
									for="Checkbox-reminder"
									>Attachment</label
								>
							</div>
						</div>
						<div v-if="attachmentState.enabled" class="row">
							<div class="col-sm-3">
								<BaseFileInput
									name="Browse Images"
									label="Browse Images"
									type="file"
									@update:modelValue="uploadImage"
								/>
							</div>
						</div>
					</div> -->

					<div class="form-group col-sm-12 mt-2">
						<BaseButton
							class="btn bg-blue text-white form-control"
							type="submit"
							label="Save"
							:disabled="formState.disable"
							:loading="formState.isLoading"
						/>
					</div>
				</div>
			</div>
			<!--  notes -->
					<div  v-if="isHidden"  class="col-sm-3 notes">
						<div class="col-sm-12">
							<div class="row">
								<div class="col-sm-12">
									<div class="yellow-color-bg text-white d-flex justify-content-between align-items-center px-2 mb-1">
										<h4 class="">Global Trip Holidays</h4>
										<i @click="isHidden = !isHidden" class="bi bi-x-circle-fill fs-5"></i>
									</div>
									<p class="text-gray">
										Editing Lead will modify it's existing data. Proceed with caution.
									</p>
								</div>
								<div class="col-sm-12">
									<BaseTextArea
										v-model="data.notes"
										name="Notes"
										label="Notes"
										@valError="valError"
										@valSuccess="valSuccess"
									/>
								</div>
							</div>
						</div>
					</div>


					<div @click="isHidden = !isHidden" v-if="!isHidden"  class="note-button">
						<i class="bi bi-journal-bookmark-fill"></i>
						<h6>Notes</h6>
					</div>
		</div>
	</form>
</template>
<script>
	import {
		reactive,
		ref,
		inject,
		watchEffect,
		watch,
		computed,
		onMounted,
		onBeforeUnmount,
	} from "vue";
	import { useRouter } from "vue-router";

	import API from "@/config/api";
	import toast from "@/config/toast";
	import Data from "@/helpers/dataHelper";

	import BaseInput from "./BaseInput.vue";
	import BaseButton from "./BaseButton.vue";
	import BaseFileInput from "./BaseFileInput.vue";
	import BaseTextArea from "./BaseTextArea.vue";
	import BaseMultiSelect from "./BaseMultiSelect.vue";

	import LeadPackage from "./LeadPackage.vue";
	import LeadOther from "./LeadOther.vue";
	import LeadCustomizePackage from "./LeadCustomizePackage.vue";

	import DynamicMultiplier from "./DynamicMultiplier.vue";

	export default {
		name: "LeadCreate",
		components: {
			BaseInput,
			BaseButton,
			BaseMultiSelect,
			LeadPackage,
			BaseTextArea,
			BaseFileInput,
			LeadOther,
			DynamicMultiplier,
			LeadCustomizePackage,
		},
		setup: () => {
			const store = inject("store");
			const leadState = inject("leadState");
			const packageEditState = inject("packageEditState");
			const masterStore = inject("masterStore");
			const router = useRouter();

			if (!store.state.auth.isAuth) router.push({ name: "Login" });

			const activeComponent = masterStore.state.activeComponent;

			const data = reactive({
				phone: null,
				email: null,
				salutation: null,
				firstName: null,
				lastName: null,
				dateOfBirth: null,
				anniversary: null,
				address: null,
				city: null,
				alternatePhone: null,
				alternateEmail: null,
				customerType: null,
				leadSource: null,
				leadPriority: null,
				leadStatus: null,
				adults: 0,
				childrenTwoFive: 0,
				childrenFiveTwelve: 0,
				infants: 0,
				tripType: null,
				tags: [],
				assignedTo: null,
				enquiryType: [],
				reminder: {
					status: false,
					description: null,
					date: null,
					time: null,
				},
				attachment: [],
				notes: null,
				flightBooking: [],
				hotelBooking: [],
				visa: [],
				travelInsurance: [],
				forex: [],
				sightseeing: [],
				transport: [],
				other: {
					status: false,
				},
				package: {
					status: false,
				},
				customizePackage: {
					status: false,
				},
				whatsappOptIn: false,
			});

			leadState.state.data = data;

			const attachmentState = reactive({
				enabled: false,
			});

			const formState = reactive({
				isLoading: false,
				disable: false,
			});

			const validation = reactive({
				invalid: [],
				valid: [],
				nullable: [],
			});

			const multiSelectState = reactive({
				tags: [],
				tagsSelect: [],
				customerType: Data.customerType,
				leadSources: Data.leadSource,
				leadPriority: Data.leadPriority,
				leadStatus: Data.leadStatus,
				tripType: Data.tripType,
				enquiryType: Data.enquiryType,
				salutations: Data.salutations,
				users: [],
				usersSelect: [],
			});

			const roleAuth = reactive({
				assignNotAllowedTo: ["SALES_EXECUTIVE"],
			});

			const whatsapp = ref(false);

			const isHidden = ref(false);

			const shouldAssign = computed(() => {
				return roleAuth.assignNotAllowedTo.includes(store.state.user.role[0]);
			});

			const changeFormLoadingState = () =>
				(formState.isLoading = !formState.isLoading);

			const getUsers = async () => {
				try {
					const users = await API.privateRequest.get("/users?filter=1");
					multiSelectState.users = users.data.data;
					multiSelectState.usersSelect = users.data.data.map((item) => {
						return {
							value: item._id,
							label: `${item.firstName} ${item.lastName}`,
						};
					});
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error !";
					}

					toast.error(message, true);
				}
			};

			const getTags = async () => {
				try {
					const response = await API.privateRequest.get("tags");
					const changedTags = response.data.data.map((tag) => ({
						value: tag._id,
						label: tag.name,
					}));
					multiSelectState.tags = response.data.data;
					multiSelectState.tagsSelect = changedTags;
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error !";
					}

					toast.error(message, true);
				}
			};

			const customerState = reactive({
				types: [],
				fetched: false,
				count: 0,
			});

			const findCustomer = async (value, type = "email") => {
				if (masterStore.state.activeComponent === "edit") return;
				if (!value) return;

				if (
					(type === "phone" && value.length !== 10) ||
					(customerState.fetched && customerState.types.includes(type))
				) {
					return;
				} else if (
					(type === "email" &&
						!value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) ||
					(customerState.fetched &&
						customerState.types.includes(type) &&
						customerState.count > 3)
				) {
					return;
				}

				try {
					const customer = await API.privateRequest.get(
						`customers?${type}=${value}`,
					);
					customerState.fetched = true;

					if (!customerState.types.includes(type)) {
						customerState.types = [...customerState.types, type];
						if (type === "email" && customerState.count < 3) {
							customerState.count = customer.count + 1;
						}
					}

					if (customer.data.data.length) {
						data.salutation = customer.data.data[0].name.salutation;
						data.firstName = customer.data.data[0].name.firstName;
						data.lastName = customer.data.data[0].name.lastName;
						data.dateOfBirth = customer.data.data[0]?.dateOfBirth ? customer.data.data[0]?.dateOfBirth.split("T")[0] : null,
						data.anniversary = customer.data.data[0]?.anniversary ? customer.data.data[0]?.anniversary.split("T")[0] : null,
						data.address = customer.data.data[0].address.loc;
						data.city = customer.data.data[0].address.city;
						if (data.phone) {
							data.email = customer.data.data[0].email;
						} else {
							data.phone = customer.data.data[0].phone;
						}
					}
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error !";
					}

					toast.error(message, true);
				}
			};

			

			const setSalutation = (salutation) => {
				data.salutation = salutation;
			};

			const setLeadSource = (dataString) => {
				data.leadSource = dataString;
			};

			const setAssignedTo = (dataObj) => {
				data.assignedTo = dataObj;
			};

			const setCustomerType = (dataObj) => {
				data.customerType = dataObj;
			};

			const setLeadPriority = (dataObj) => {
				data.leadPriority = dataObj;
			};

			const setLeadStatus = (dataObj) => {
				data.leadStatus = dataObj;
			};
			const setTripType = (dataObj) => {
				data.tripType = dataObj;
			};
			const setTag = (dataObj) => {
				data.tags = dataObj;
			};

			onMounted(() => {
				getTags();
				getUsers();
			});

			const uploadImage = async (e) => {
				try {
					changeFormLoadingState();
					let setByThis = false;
					if (!formState.disable) {
						formState.disable = true;
						setByThis = true;
					}
					const formData = new FormData();
					Object.keys(e).map((key) => formData.append("attachment", e[key]));
					const response = await API.privateRequest.post("files", formData, {
						headers: { "Content-Type": "multipart/form-data" },
					});
					response.data.data.map((obj) => data.attachment.push(obj.url));
					changeFormLoadingState();
					if (setByThis && formState.disable) formState.disable = false;
				} catch (err) {
					changeFormLoadingState();
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error !";
					}

					toast.error(message, true);
				}
			};


			

			const whatsappOptIn = async () => {
				if (!data.phone || data.phone.length < 10) {
					data.whatsappOptIn = false;
					return;
				} 

				console.log("data", data.whatsappOptIn);
				if (!data.whatsappOptIn) return;

				try {
					await API.privateRequest.get(`opt-in?phone=${data.phone}`);
					toast.success("Whatsapp Opt In success", true);
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error !";
					}

					toast.error(message, true);
					changeFormLoadingState();
					// formState.disable = false;
				}
			}
			// watch(
			// 	data,
			// 	(newValue, preValue) => {
			// 		if (data.phone && data.whatsappOptIn) whatsappOptIn();
			// 	},
			// 	{ deep: true }
			// )

			watchEffect(() => {
				findCustomer(data.phone, "phone");
				findCustomer(data.email, "email");
			});

			watchEffect(
				() => whatsappOptIn(data.whatsappOptIn)
			);
			const shapeData = async (data) => {
				if (data.enquiryType.includes("Package")) {
					if (leadState.state.data.package.edited) {
						leadState.state.data.package.packageData =
							packageEditState.state.data;
					}

					leadState.state.data.package.packageId =
						packageEditState.state.data?._id ||
						leadState.state.data.package.packageData?._id;

					leadState.state.data.package?.itinerary
						? leadState.state.data.package.itinerary.map((itinerary) => {
								delete itinerary._id;
								if (itinerary?.sightSeeing.length) {
									let sight = itinerary.sightSeeing.map((sight) =>
										sight instanceof Object ? sight._id : sight,
									);
									itinerary.sightSeeing = sight;
								}
						  })
						: (leadState.state.data.package.itinerary = []);
				}

				const newData = { ...data };

				newData.name = {
					salutation: data.salutation || null,
					firstName: data.firstName || null,
					lastName: data.lastName || null,
				};

				delete newData.salutation;
				delete newData.firstName;
				delete newData.lastName;

				if (data.reminder.status) {
					if (!newData?.reminder?.date.includes("T")) {
						newData.reminder.date = `${data.reminder.date}T${data.reminder.time}:00.000Z`;
						delete newData.reminder.time;
					}
				} else if (!data.reminder.status) {
					delete newData.reminder.time;
				}

				return newData;
			};

			const createLead = async () => {
				changeFormLoadingState();
				formState.disable = false;

				let transformedData = await shapeData(leadState.state.data);
				if (data.enquiryType.includes('Package')) {
					transformedData.package.packageId = transformedData?.package?.packageData?._id;
					delete transformedData?.package?.packageData;
				} 
				try {
					if (activeComponent === "edit") {

						await API.privateRequest.patch(
							`leads/${masterStore.state.editId}`,
							transformedData,
						);
						toast.success(
							{ message: "Lead updated!", position: "topRight" },
							true,
						);
					} else {
						await API.privateRequest.post("leads", transformedData);
						toast.success(
							{ message: "Lead created!", position: "topRight" },
							true,
						);
					}

					changeFormLoadingState();
					masterStore.methods.changeComponent("table");
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error !";
					}

					toast.error(message, true);
					changeFormLoadingState();
					// formState.disable = false;
				}
				return;
			};

			// ? setting component state for lead updation
			if (activeComponent === "edit") {
				let dataKeys = Object.keys(data);

				let masterData = { ...masterStore.state.data };

				dataKeys.map((key) => {
					data[key] = masterData[key] || data[key];
				});
				data.salutation = masterData.name.salutation;
				data.firstName = masterData.name.firstName;
				data.lastName = masterData.name.lastName;
				data.city = masterData?.address?.city || null;
				data.address = masterData?.address?.loc || null;
				data.dateOfBirth = data?.dateOfBirth ? data.dateOfBirth.split("T")[0] : null;
				data.anniversary = data?.anniversary ? data.anniversary.split("T")[0] : null;
				
				data.assignedTo = masterData?.assignedTo?._id || null;
				data.tags = masterData.tags.map((tag) => tag._id);
				data.notes = null;
				let date = masterData.reminder?.date;
				data.reminder.date = date ? date.split("T")[0] : null;
				data.reminder.time = date
					? date.split("T")[1].replace(":00.000Z", "")
					: null;

				leadState.state.data = data;
			}

			//? checking conditions to enable or disable form login button
			const checkForm = () => {
				let valLength = validation.valid.length;
				let inValLength = validation.invalid.length;
				let formLength = Object.keys(data).length;
				let formInputs = Object.keys(data); //!formInputs should be in formState
				let nullables = Object.values(validation.nullable);
				let notNullable = [];

				for (let nullable of nullables) {
					for (let [index, formInput] of formInputs.entries()) {
						if (nullable === formInput) {
							delete formInputs[index];
							break;
						} else if (!formInput) break;
						else notNullable.push(formInput);
					}
				}
				notNullable = [...new Set(notNullable)];

				let notNullableInvalids = notNullable.flatMap((item) => {
					let catchInValid = validation.invalid.includes(item);
					return catchInValid;
				});

				//? removing falsy values from array
				let check = notNullableInvalids.filter(Boolean);

				if (
					!inValLength &&
					!check.length &&
					valLength + notNullable.length >= formLength
				) {
					formState.disable = false;
				} else formState.disable = true;
			};

			//? adding and removing form fields from valid and invalid state
			const setFormVal = (data) => {
				if (validation.invalid.length) {
					const newInvalid = validation.invalid.filter(
						(error) => error.field !== data.field,
					);
					validation.invalid = newInvalid;
				}
				if (validation.valid.length) {
					const newValid = validation.valid.filter(
						(item) => item.field !== data.field,
					);
					validation.valid = newValid;
				}
				return;
			};

			// event handler for valError event
			const valError = (data) => {
				// toast.error(`${data.field} is required`, true);
				// setFormVal(data);
				// validation.invalid = [...validation.invalid, data];
				// checkForm();
			};

			const valSuccess = (data) => {
				// setFormVal(data);
				// validation.valid = [...validation.valid, data];
				// checkForm();
			};

			onBeforeUnmount(() => {
				masterStore.methods.destroy();
				packageEditState.state.data = {};
				packageEditState.state.editBool = false;
			});

			return {
				store,
				data,
				multiSelectState,
				leadState,
				attachmentState,
				whatsapp,
				createLead,
				valError,
				valSuccess,
				validation,
				formState,
				setSalutation,
				setLeadSource,
				setLeadPriority,
				setAssignedTo,
				setCustomerType,
				setLeadStatus,
				setTripType,
				setTag,
				uploadImage,

				shouldAssign,
				isHidden,
			};
		},
	};
</script>
<style scoped>
.text-gray{
	color: #999;
	font-size: 16px;
}
label.form-check-label.mx-2.text-dark {
    color: #00A0E3!important;
}
.note-button{
	position: fixed;
	display: flex;
    flex-direction: column;
    justify-content: end;
    align-items: center;
	background:#F4BB22;
	bottom: 85px;
	right: 70px;
	width: 70px;
	height: 70px;
	line-height: 30px;
	border-radius: 50%;
	box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
}
.note-button h6{
	font-size: 10px;
	color: #fff;
	z-index: 999;
}
.bi-journal-bookmark-fill::before {
    content: "\f43c";
    font-size: 30px;
    color: #fff;
}
.notes{
	position: fixed;
	bottom: 75px;
	right: 50px;
	background-color: #fff;
	border-radius: 10px;
	padding: 20px;
	z-index: 999;
	box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
}
</style>


